

function openDeviceCalendar (calendarURL, options = null) {

    console.log('appClientStore.openDeviceCalendar() : ', calendarURL);
    this.notifyClientPage({
        action: 'openDeviceCalendar',
        data: {
            calendarURL,
            options,
        },
    });
}

export default openDeviceCalendar;
